export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.3.6-1006.58',
  commitId: '23e19ccfdfa7f0bd12d28dc70ad8f1e43643f4c3',
  commitTime: '2026-03-06T10:06:58.000Z',
});
